// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"06f852fc","703":"a4025afe"}[chunkId] + ".chunk.js";
};